import * as d3 from "d3-new";
import { createTooltip } from "@/shared/charts/utils";

export const generateDonutChart = (
  data,
  colors,
  colorMap,
  onSelect,
  size
) => {
  const width = size;
  const height = size;
  const radius = Math.min(height, width) / 2;

  const arc = d3
    .arc()
    .innerRadius(radius * 0.5)
    .outerRadius(radius - 1);

  const pie = d3
    .pie()
    .sort(null)
    .value((d) => d.value ?? 0);

  const svg = d3
    .create("svg")
    .attr("height", height)
    .attr("width", width)
    .attr("viewBox", [-width / 2, -height / 2, width, height]);
  var circleRadians = 6.28319;
  var cumulativeDelay = 0;

  data = data
    .map((da, i) => {
      da.originalIndex = i;
      return da;
    })
    .sort((a, b) => b.value - a.value);

  var pieData = pie(data).map((pd, i) => {
    var newPd = { ...pd };
    var durationPercentage = (pd.endAngle - pd.startAngle) / circleRadians;

    newPd.duration = 500 * durationPercentage;
    newPd.delay = cumulativeDelay;
    cumulativeDelay += newPd.duration;

    return newPd;
  });
  var chart = svg
    .append("g")
    .selectAll()
    .data(pieData)
    .join("path")
    .attr(
      "fill",
      (d, i) => colorMap[d.data.originalName] || colors[d.data.originalIndex],
    );

  createTooltip(
    chart,
    "donut-chart-tooltip",
    (d) =>
      `${d.data.name} ${d.data.value} (${d.data.percentage}%)`,
  );

  chart.on("click", (e, d) => {
    e.stopPropagation();
    onSelect(d.data.id);
  });

  chart
    .transition()
    .duration((d) => d.duration)
    .delay((d) => d.delay)
    .attrTween("d", (d) => {
      var i = d3.interpolate(d.startAngle + 0.1, d.endAngle);
      return (t) => {
        d.endAngle = i(t);
        return arc(d);
      };
    });

  return svg.node();
};
